import React, { RefObject } from 'react';
import { View, Text, TouchableOpacity, Platform } from 'react-native';
import styles from '../../styles/AppStyles';
import { TemplateFile } from '../types/LandingPageTypes';

interface UploadSectionProps {
  templateFile: TemplateFile | null;
  pickTemplateFile: () => void;
  handleFileInput: (e: React.ChangeEvent<HTMLInputElement>) => void;
  jsonInputRef: RefObject<HTMLInputElement | null>;
  fromScratchMode: boolean;
  recentWordPressTemplates: Array<{ id: number | string; title: string }>;
  selectedWordPressTemplateId: string | null;
  setSelectedWordPressTemplateId: (id: string | null) => void;
  loadSelectedWordPressTemplate: (id?: string | null) => void;
}

const UploadSection: React.FC<UploadSectionProps> = ({
  templateFile,
  pickTemplateFile,
  handleFileInput,
  jsonInputRef,
  fromScratchMode,
  recentWordPressTemplates,
  selectedWordPressTemplateId,
  setSelectedWordPressTemplateId,
  loadSelectedWordPressTemplate,
}) => {
  if (fromScratchMode) {
    return null;
  }

  const isUploadDisabled = false;

  return (
    <View style={styles.fileUploadSection}>
      <View style={styles.uploadBox}>
        <Text style={styles.boxLabelTextFilePicker}>
          {templateFile ? templateFile.name : 'No File Selected'}
        </Text>
      </View>
     
      <View>
        <TouchableOpacity
          style={[styles.button, styles.secondaryButton, isUploadDisabled && { opacity: 0.5 }]}
          onPress={pickTemplateFile}
          disabled={isUploadDisabled}
        >
          <Text style={styles.secondaryButtonText}>Upload Elementor Template (JSON)</Text>
        </TouchableOpacity>

        {Platform.OS === 'web' && !isUploadDisabled && (
          <input
            ref={jsonInputRef}
            type="file"
            accept="application/json"
            style={{ display: 'none' }}
            onChange={handleFileInput}
          />
        )}
      </View>
      {Platform.OS === 'web' && recentWordPressTemplates.length > 0 && (
        <View style={{ width: '100%', gap: 8 }}>
          <select
            aria-label="Recent WordPress template"
            value={selectedWordPressTemplateId ?? ''}
            onChange={event => setSelectedWordPressTemplateId(event.target.value)}
            style={{ width: '100%', minHeight: 40, padding: 8 }}
          >
            {recentWordPressTemplates.map(template => (
              <option key={template.id} value={template.id}>{template.title}</option>
            ))}
          </select>
          <TouchableOpacity
            style={[styles.button, styles.secondaryButton]}
            onPress={() => loadSelectedWordPressTemplate()}
          >
            <Text style={styles.secondaryButtonText}>Load WordPress Template</Text>
          </TouchableOpacity>
        </View>
      )}
    </View>
  );
};

export default UploadSection;
